import { useRef } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import { useEntityTypeFilter } from "../../../../../../hooks/useEntityTypeFilter";

const EntityButton = () => {
  useEntityTypeFilter();

  const filterRef = useRef<HTMLDivElement>(null);

  const entityDropdownClassnames = classNames(
    styles.entityDropdown,
    styles.disabledEntityDropdown,
    {},
  );

  const selectedTitle = "Images"; // Hardcode since it's always the same
  const content = `Apply this filter to display only the data entries from Images type`;

  return (
    <div
      className={entityDropdownClassnames}
      ref={filterRef}
      data-tooltip-content={content}
      data-tooltip-id="entity-filter"
    >
      {<TooltipWrapper id="entity-filter" />}
      <div className={styles.header} data-testid="entity-filter-button">
        <div className={styles.selectedTitle}>{selectedTitle}</div>
      </div>
    </div>
  );
};

export default EntityButton;
